import React from 'react';
import styled from 'styled-components';

import AllTasksCompleteImg from './allTasksComplete.svg';
import Typography from 'kingpin/atoms/Typography';
import Row from '../Common/Row';
import FlexCentered from '../Common/FlexCentered';

const Img = styled.img`
  width: 130px;
  margin-bottom: 16px;
`;

const AllTasksComplete = () => (
  <FlexCentered>
    <div>
      <div>
        <Img src={AllTasksCompleteImg} />
      </div>
      <Row style={{ justifyContent: 'center' }}>
        <Typography.Body type="Body 12">All tasks complete</Typography.Body>
      </Row>
    </div>
  </FlexCentered>
);

export default AllTasksComplete;
